import { render, staticRenderFns } from "./UpdateRiskViewpoint.vue?vue&type=template&id=d041fdcc&scoped=true"
import script from "./UpdateRiskViewpoint.vue?vue&type=script&lang=js"
export * from "./UpdateRiskViewpoint.vue?vue&type=script&lang=js"
import style0 from "./UpdateRiskViewpoint.vue?vue&type=style&index=0&id=d041fdcc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d041fdcc",
  null
  
)

export default component.exports